import { render, staticRenderFns } from "./RequestNewMasterpayer.vue?vue&type=template&id=6c7e7b0b&scoped=true&"
import script from "./RequestNewMasterpayer.vue?vue&type=script&lang=js&"
export * from "./RequestNewMasterpayer.vue?vue&type=script&lang=js&"
import style0 from "./RequestNewMasterpayer.vue?vue&type=style&index=0&id=6c7e7b0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e7b0b",
  null
  
)

export default component.exports